<template>
  <div class="onboarding-step">
    <h2 class="step-title">Content preferences</h2>
    <p class="step-description">
      Help us understand what topics you want to cover and monitor.
    </p>

    <TagInput
      v-model="localData.fieldsOfInterest"
      label="Fields of Interest (press enter to save)"
      placeholder="e.g., SaaS, Marketing, AI"
      @update:model-value="emitUpdate"
    />

    <TagInput
      v-model="localData.keywordsToMonitor"
      label="Keywords to Monitor (press enter to save)"
      placeholder="e.g., content marketing, SEO"
      @update:model-value="emitUpdate"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import TagInput from '@/components/common/TagInput.vue'

interface StepData {
  fieldsOfInterest: string[]
  keywordsToMonitor: string[]
}

const props = defineProps<{
  initialData: StepData
}>()

const emit = defineEmits<{
  (e: 'update', data: StepData): void
}>()

const localData = ref<StepData>({
  fieldsOfInterest: [...props.initialData.fieldsOfInterest],
  keywordsToMonitor: [...props.initialData.keywordsToMonitor],
})

const emitUpdate = () => {
  emit('update', {
    fieldsOfInterest: [...localData.value.fieldsOfInterest],
    keywordsToMonitor: [...localData.value.keywordsToMonitor],
  })
}

watch(() => props.initialData, (newData) => {
  localData.value = {
    fieldsOfInterest: [...newData.fieldsOfInterest],
    keywordsToMonitor: [...newData.keywordsToMonitor],
  }
}, { deep: true })
</script>

<style scoped>
.onboarding-step {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.step-title {
  font-size: var(--text-xl);
  font-weight: var(--font-bold);
  color: var(--text-primary);
  margin: 0;
}

.step-description {
  font-size: var(--text-base);
  color: var(--text-secondary);
  margin: 0;
  line-height: var(--leading-relaxed);
}
</style>
